<template>
  <el-form
    ref="dyForm"
    class="dynamic-form"
    :inline="formConfig.inline"
    :model="value"
    :label-position="formConfig.labelPosition"
    :label-width="formConfig.labelWidth"
    :size="formConfig.size"
    :rules="rules"
  >
    <component
      :is="createWidgets(formitem)"
      v-for="(formitem, index) in formConfig.formItemList.filter(
        (item) => !item.hidden,
      )"
      :key="formitem.key + index"
      :item="formitem"
      :value="value[formitem.key]"
      @input="handleInput($event, formitem.key)"
      @change="handleChange($event, formitem.key)"
    />
    <slot />
    <slot name="sf-btns">
      <el-row class="text-r">
        <!-- <el-button size="small" @click="resetForm('dyForm')">重置</el-button> -->
        <el-button size="small" type="primary" @click="$emit('export')">
          导出
        </el-button>
        <el-button size="small" type="primary" @click="submitForm('dyForm')">
          查询
        </el-button>
      </el-row>
    </slot>
  </el-form>
</template>
<script>
/**
 * created by yuanzishu 2019/07/10
 */
import Emitter from 'element-ui/src/mixins/emitter'
import registry from './WidgetRegistry'
export default {
  name: 'dynamic-form',
  componentName: 'dynamic-form',
  mixins: [Emitter],
  props: {
    formConfig: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    conditionLength() {
      return (this.formConfig.formItemList || []).length
    },
    rules() {
      let _rules = {}
      const formItemList = this.formConfig.formItemList || []
      for (let item of formItemList) {
        const prop = item.key,
          rule = item.rules || []
        rule && rule.length && (_rules[prop] = rule)
      }
      return _rules
    },
  },
  watch: {
    conditionLength: {
      handler() {
        this.bindRelation()
      },
      immediate: true,
    },
  },
  mounted() {
    this.setDefaultValue()
    this.$on('keyup-enter', () => this.submitForm('dyForm'))
  },
  methods: {
    createWidgets(formItem) {
      const key = `df-${formItem.type}`
      const comp = registry.getType(key)
      if (!comp) {
        throw new Error('invalid formItem type')
      }
      return comp
    },
    handleChange(val, key) {
      this.$emit('change', key, Object.assign({}, this.value, { [key]: val }))
    },
    handleInput(val, key) {
      if (typeof val === 'string') {
        val = val.replace(/^\s*|\s*$/g, '')
      }
      this.$emit('input', { ...this.value, [key]: val })
    },
    //初始值和formItemList的默认值
    setDefaultValue() {
      const formData = { ...this.value } // 设置默认值
      this.formConfig.formItemList.forEach(({ key, value, defaultValue }) => {
        if (formData[key] === undefined || formData[key] === null) {
          formData[key] = value
        } else if (JSON.stringify(formData[key]) === '[null]') {
          //hack cascader resetFields =>[null]
          formData[key] = []
        }
        if (defaultValue) {
          formData[key] = defaultValue
        }
      })
      this.$emit('input', formData)
      return formData
    },
    //针对关联widget  建立依赖关联
    bindRelation() {
      const formItemList = this.formConfig.formItemList || []
      formItemList.forEach((item) => {
        const { dependence, type } = item
        dependence &&
          this.$watch('value', function (newVal, oldVal) {
            if (newVal[dependence] != oldVal[dependence]) {
              type === 'select' &&
                this.broadcast(
                  'sfSelectWidget',
                  `${dependence}-change`,
                  newVal[dependence],
                )
              type === 'cascader' &&
                this.broadcast(
                  'sfCascaderWidget',
                  `${dependence}-change`,
                  newVal[dependence],
                )
            }
          })
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.value)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('reset', this.setDefaultValue())
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.dynamic-form {
  background: #e6effb;
  padding: 24px;
  .text-r {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// DyForm.vue?bc9dff08